export default "__VITE_ASSET__DtMJlqkX__"